export default "__VITE_ASSET__84e727ac__"